import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SinglePermission } from 'utils/api/models/users/singlePermission';

export interface IUserData {
	userId: string;
	upId: string;
	accountId: string;
	userName: string;
	userType: types.users.userType;
	accountName: string;
	email: string;
	departmentId: string;
	departmentName: string;
	departmentUiColor: string;
	objectId: string;
	lastLogin: string;
	lastSentActivationEmailDate: string;
	contactNumber1: string;
}

export type CorpUserDetails = {
	_permissions: any;
	permissions: SinglePermission[];
	userData: IUserData;
};

const model: types.models.InputModel = {
	_permissions: ['response.getUserDetailsResponse.permissions', []],
	permissions: (model: CorpUserDetails) =>
		model._permissions.map((permission: any) => modelsResolver(permission, 'singlePermission')),
	userData: 'response.getUserDetailsResponse.userData',
};

export default model;
